<template>

    <div class="tabs_actions">

        <span v-if="inNewCat" class="new_cat_input_container">
            <input type="text" v-model="newCatname" v-on:keyup.enter="saveNewCat" />
            <span class="btn_valid" v-if="inNewCat"  @click="saveNewCat"><i class="icon-check"></i></span>
            <span class="btn_error" v-if="inNewCat" @click="cancelNewCat"><i class="icon-close"></i></span>
        </span>
        <span v-if="!inNewCat" class="tab_action_btn plus_button" @click="goNewCat"><i class="zmdi zmdi-plus"></i></span>

        <span class="tab_action_btn" @click="slideLeft"><i class="icon-arrow-left"></i></span>
        <span class="tab_action_btn" @click="slideRight"><i class="icon-arrow-right"></i></span>

    </div>


</template>

<script>

export default {
    name: 'CatsActions',
    components: {

    },
    data(){
        return {
            inNewCat: false,
            newCatname: ''
        }
    },
    created(){

    },
    methods: {
        goNewCat(){
            this.inNewCat = true
        },
        cancelNewCat(){
            this.inNewCat = false
        },
        saveNewCat(){
            this.$store.dispatch('RefStore/createCat', this.newCatname).then(() => {
                this.inNewCat = false
                this.newCatname = ''
            })

        },
        slideRight(){
            this.$emit('slideRight')
        },
        slideLeft(){
            this.$emit('slideLeft')
        },
    }
}
</script>

<style lang="scss">
.tabs_actions{
    position: relative;
    display: flex;
    align-items: center;
    .tab_action_btn{
        padding: 0 10px;
        cursor: pointer;
        transition: .3s all;
        &.plus_button{
            border: 2px solid $info;
            color: $info;
            border-radius: 5px;
            width: 26px;
            height: 26px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.2rem;
        }
    }
    .new_cat_input_container{
        transition: .3s all;
        position: absolute;
        right: 100%;
        display: flex;
        background: $white;
        padding: 0px 18px;
        span{
            padding: 0 10px;
            cursor: pointer;
            font-size: 1.2rem;
            &.btn_valid{
                color: $success;
            }
            &.btn_error{
                color: $danger;
            }

        }
    }
}


</style>